import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ChangeFilter } from '@/api/contracts/dataModel';
import { getDistinctAuditUsers } from '@/api/endpoints/dataViewAudit';

export const useDataViewAuditFilterStore = defineStore('dataViewAuditFilter', () => {
  const currentFilter = ref<ChangeFilter | null>(null);
  const availableUsers = ref<string[]>([]);
  const loadingUsers = ref(false);
  const usersError = ref<string | null>(null);
  const usersTableKey = ref<string | null>(null);

  function setFilter (filter: ChangeFilter): void {
    currentFilter.value = {
      fromDate: filter.fromDate,
      toDate: filter.toDate ?? null,
      modifiedBy: filter.modifiedBy ?? null
    };
  }

  function clearFilter (): void {
    currentFilter.value = null;
  }

  async function loadDistinctUsers (tableKey: string, signal?: AbortSignal): Promise<void> {
    const normalized = String(tableKey || '').trim();
    if (!normalized) {
      availableUsers.value = [];
      usersTableKey.value = null;
      return;
    }
    if (normalized === usersTableKey.value && availableUsers.value.length > 0) return;
    loadingUsers.value = true;
    usersError.value = null;
    try {
      availableUsers.value = await getDistinctAuditUsers(normalized, signal);
      usersTableKey.value = normalized;
    } catch (e) {
      availableUsers.value = [];
      usersError.value = e instanceof Error ? e.message : 'Ukjent feil';
    } finally {
      loadingUsers.value = false;
    }
  }

  function reset (): void {
    currentFilter.value = null;
    availableUsers.value = [];
    loadingUsers.value = false;
    usersError.value = null;
    usersTableKey.value = null;
  }

  return {
    currentFilter,
    availableUsers,
    loadingUsers,
    usersError,
    setFilter,
    clearFilter,
    loadDistinctUsers,
    reset
  };
});
